import React from 'react';
import { IIconProps } from '../interfaces';

const DotsIcon = (props: IIconProps) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={ props.width }
            height={ props.width }
            className={ props.classes ?? undefined }
            fill="none">
            <path fill={ props.color || '#000' } d="M4.75 8.5c-.825 0-1.5.675-1.5 1.5s.675 1.5 1.5 1.5 1.5-.675 1.5-1.5-.675-1.5-1.5-1.5Zm10.5 0c-.825 0-1.5.675-1.5 1.5s.675 1.5 1.5 1.5 1.5-.675 1.5-1.5-.675-1.5-1.5-1.5ZM10 8.5c-.825 0-1.5.675-1.5 1.5s.675 1.5 1.5 1.5 1.5-.675 1.5-1.5-.675-1.5-1.5-1.5Z"/>
        </svg>
    )
};

export default DotsIcon;